// extracted by mini-css-extract-plugin
export default {"container":"CuisinesSection-module__container__JHas7","text":"CuisinesSection-module__text__wE5Ms"};